import { render, staticRenderFns } from "./cutarrow.vue?vue&type=template&id=15b8641b&scoped=true"
import script from "./cutarrow.vue?vue&type=script&lang=ts"
export * from "./cutarrow.vue?vue&type=script&lang=ts"
import style0 from "./cutarrow.vue?vue&type=style&index=0&id=15b8641b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b8641b",
  null
  
)

export default component.exports